<template>
	<div class="popup-warning overlay">
		<div class="popup">
			<div class="content">{{ popup.message }}</div>
			<div class="btn-wrapper">
				<Button class="popup-btn" :action="advance">{{ popup.continue_button }}</Button>
				<Button class="popup-btn" :action="close">{{ popup.close_button }}</Button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Button from "@/components/abstract/Button";

export default {
	name: 'PopupWarning',
	components: {
		Button,
	},
	props: {
		externalUrl: {
			type: String,
			required: true,
		},
	},
	computed: {
		...mapState({
			popup: state => state.config.ui.popup_warning,
		}),
	},
	methods: {
		advance() {
			window.open(this.externalUrl, '_blank');
			this.$emit('close');
		},
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
	.overlay {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		z-index: 500;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.popup {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		max-width: 400px;
		padding: 2rem;
		background: $red;
		color: white;
	}

	.content {
		text-align: center;
		margin-bottom: 1rem;
	}

	.btn-wrapper {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

	}
	.popup-btn {
		color: $red;

		& + & { margin-top: 1rem; }
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/PopupWarning.vue